import { SET_CONFIGURATION_VENUE } from "../../assets/constants/reducer.type";

  export const setConfigVenueList = (payload) => {
    return { type: SET_CONFIGURATION_VENUE, payload };
  };